var industryInfo={
    classList:[
        {
            'name':"机器视觉系统",
            'list':[
                {
                    'picUrl':"https://image.sjyuan.net.cn/video/mvb/case/%E5%95%86%E4%B8%9A%E6%99%BA%E8%83%BD%E6%9C%8D%E5%8A%A1-3D%E7%9B%B8%E6%9C%BA.jpg",
                    'title':"客流计与行为分析",
                    'lable':"高精度的客流统计，关键通道的防尾随、测身高、异常行李及异常行为的识别等先进功能。适用于传统2D视觉方案不能胜任的难度场景，如车站、机场等人流密集处，或海关、银行等安全敏感场所。",
                    'list':[
                        {
                            'icon':"/static/case/hj.png",
                            'title':"环境适应性强"
                        },
                        {
                            'icon':"/static/case/jd.png",
                            'title':"可达到98%以上精度"
                        },
                        {
                            'icon':"/static/case/xjjc.png",
                            'title':"支持多相机扩展检测"
                        }
                        
                    ]
                   
                }
            ]
        },
        {
            'name':"协作机器人",
            'list':[
                {
                    'videoUrl':"https://image.sjyuan.net.cn/video/mvb/case/bql.mp4",
                    'title':"机器人冰淇淋甜品站",
                    'lable':"机器人甜品站包括乐白智能机器人、取放甜筒及检测机构、冰淇淋机压杆机构、设备控制系统及机器人通讯方案、订单管理调度系统、零售支付软件接口，轻松实现消费者自助及时消费。该设备可应用于商场、餐厅、酒吧等多场景，帮助店家引流营销。",
                    'list':[
                        {
                            'icon':"/static/case/az.png",
                            'title':"灵活部署"
                        },
                        {
                            'icon':"/static/case/lcjd.png",
                            'title':"流程简单"
                        },
                        {
                            'icon':"/static/case/rg.png",
                            'title':"低人工成本"
                        }
                        ,
                        {
                            'icon':"/static/case/aq.png",
                            'title':"低安全隐患"
                        }
                    ]
                    ,
                    'process':[
                        {
                            'icon':"/static/case/dd.png",
                            'title':"扫码点单"
                        },
                        {
                            'icon':"/static/case/qtt.png",
                            'title':"机器人取甜筒"
                        },{
                            'icon':"/static/case/zzbql.png",
                            'title':"制作冰淇淋"
                        },
                        {
                            'icon':"/static/case/frdqt.png",
                            'title':"放入待取台"
                        },
                    ]
                }
                ,
                {
                    'videoUrl':"https://image.sjyuan.net.cn/video/mvb/case/jqrkf.mp4",
                    'title':"咖啡机器人",
                    'lable':"该方案包括物料定量添加机构、取放杯子及检测机构、订单管理调度系统、乐白LM3机器人等，无需另加控制系统，利用LM3机器人主机及自带的IO，灵活的编程调试功能。轻松实现取杯、制作、加料、封口等一系列制作流程。",
                    'list':[
                        {
                            'icon':"/static/case/az.png",
                            'title':"灵活部署"
                        },
                        {
                            'icon':"/static/case/lcjd.png",
                            'title':"流程简单"
                        },
                        {
                            'icon':"/static/case/rg.png",
                            'title':"低人工成本"
                        }
                        ,
                        {
                            'icon':"/static/case/aq.png",
                            'title':"低安全隐患"
                        }
                    ]
                    ,
                    'process':[
                        {
                            'icon':"/static/case/qb.png",
                            'title':"取杯"
                        },
                        {
                            'icon':"/static/case/zzkf.png",
                            'title':"制作咖啡"
                        },{
                            'icon':"/static/case/jrsc.png",
                            'title':"加糖浆"
                        },
                        {
                            'icon':"/static/case/ggz.png",
                            'title':"盖盖子"
                        },
                    ]
                }
                ,
                {
                    'videoUrl':"https://image.sjyuan.net.cn/video/mvb/case/zmjqr.mp4",
                    'title':"机器人厨师",
                    'lable':"客人通过触屏点餐，机器人会自动取材、加料、出餐，实现一整套全流程自动化操作。LM3机器人标准规范的操作，使餐品品质更加稳定，可同时处理多份订单。",
                    'list':[
                        {
                            'icon':"/static/case/aq.png",
                            'title':"安全卫生"
                        },
                        {
                            'icon':"/static/case/az.png",
                            'title':"灵活部署"
                        },
                        {
                            'icon':"/static/case/syxq.png",
                            'title':"实用性强"
                        }
                        ,
                        {
                            'icon':"/static/case/xn.png",
                            'title':"性能稳定"
                        }
                    ]
                    ,
                    'process':[
                        {
                            'icon':"/static/case/dd.png",
                            'title':"点单"
                        },
                        {
                            'icon':"/static/case/zqwl.png",
                            'title':"取食材倒入锅中"
                        },{
                            'icon':"/static/case/bfcj.png",
                            'title':"摆放餐具"
                        },
                        {
                            'icon':"/static/case/jrsc.png",
                            'title':"成熟食材入碗加汤"
                        },
                        {
                            'icon':"/static/case/frdqt.png",
                            'title':"输送至待取区"
                        }
                    ]
                }           
            ]
        }
    ],
    name:"商业智能服务",
    title:"solutions",
    subtitle:"商业智能服务应用案例",
    subinfo:"我们的应用案例包括用于零售、餐饮、酒店、安防等场景的可落地商业化应用，赋能商业服务新未来。",
}

export default {
    industryInfo
  };


// WEBPACK FOOTER //
// ./src/data/industryInfo/3.js